import { useRef, useState } from 'react';
import classNames from 'classnames';
import CirclePlayIcon from './circle-play-icon';
import SquarePlayIcon from './square-play-icon';
interface Props {
  url: string;
  thumbnail?: string;
  className?: string;
  showPlayIcon?: boolean;
  playIcon?: 'square' | 'circle';
}
export const VideoPlayer = ({
  url,
  thumbnail,
  showPlayIcon = false,
  className,
  playIcon = 'square'
}: Props) => {
  const videoElement = useRef<HTMLVideoElement | null>(null);
  const [paused, setPaused] = useState(true);
  const [playing, setPlaying] = useState(false);
  const updatePaused = (event: React.SyntheticEvent<HTMLVideoElement, Event>) => {
    setPaused(event.currentTarget.paused);
    setPlaying(event.type === 'playing');
  };
  const play = () => {
    if (videoElement.current) {
      videoElement.current.play();
      videoElement.current.setAttribute('controls', 'true');
    }
  };
  return <div className={classNames('relative h-full w-full', className)} data-sentry-component="VideoPlayer" data-sentry-source-file="video-player.tsx">
            <video ref={videoElement} className='h-full w-full' poster={thumbnail || ''} onCanPlay={updatePaused} onPlaying={updatePaused} onPause={updatePaused}>
                <source src={url} />
            </video>
            {!playing || paused ? <div className={classNames('absolute right-0 top-0 h-full w-full cursor-pointer items-center justify-center bg-surface-scrim-black lg:flex', showPlayIcon ? 'flex' : 'hidden')} onClick={play}>
                    {paused && (playIcon === 'square' ? <SquarePlayIcon /> : <CirclePlayIcon />)}
                </div> : null}
        </div>;
};